var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon13Bill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4740_1337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.04843 6.57474H3.16308C1.96979 6.57474 1.00195 5.53265 1.00195 4.24781C1.00195 2.96494 1.96979 1.92285 3.16308 1.92285H20.8389C22.0322 1.92285 23 2.96494 23 4.24978C23 5.53462 22.0322 6.57671 20.8389 6.57671H19.9535",
    stroke: "#46B476",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.04834 1.92285V19.3008L6.03533 21.0771L8.02232 19.3008L10.0093 21.0771L11.9981 19.3008L13.987 21.0771L15.9739 19.3008L17.9628 21.0771L19.9516 19.3008V1.92285H4.04834Z",
    stroke: "#46B476",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7H14",
    stroke: "#46B476",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10H11",
    stroke: "#46B476",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4740_1337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon13Bill);
export default __webpack_public_path__ + "static/media/icon13_bill.6359a476296429d116862fcc2e62667f.svg";
export { ForwardRef as ReactComponent };